import styled from '@emotion/styled';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'next-i18next';
import { showModalAtom } from 'src/stores/modal/atoms';
import { ModalType } from 'src/types/Modal';
import SubscriptionModal from '.';
const UnlimitedBadge = styled.button`
  position: absolute;
  z-index: 3;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  padding: 5px 12px 5px 8px;
  align-items: center;
  gap: 4px;
  flex-direction: row;

  border-radius: 360px;
  background-color: ${({
  theme
}) => theme.color.surfaceBright};
  cursor: pointer;
`;
const BadgeIcon = styled.img`
  width: 32px;
  height: 16px;
`;
const Message = styled.p`
  color: ${({
  theme
}) => theme.color.contentDeep};
  font-size: 12px;
  font-style: italic;
  font-weight: 1000;
`;
const Badge = () => {
  const {
    t
  } = useTranslation();
  const showModal = useSetAtom(showModalAtom);
  const handleClickSubscribe = () => {
    showModal({
      key: ModalType.SUBSCRIPTION_POPUP,
      component: () => <SubscriptionModal referrer='mirror' />
    });
  };
  return <UnlimitedBadge onClick={handleClickSubscribe} data-sentry-element="UnlimitedBadge" data-sentry-component="Badge" data-sentry-source-file="Badge.tsx">
      <BadgeIcon src='/vividi/images/icons/icUnlimited.png' alt='unlimited' data-sentry-element="BadgeIcon" data-sentry-source-file="Badge.tsx" />
      <Message data-sentry-element="Message" data-sentry-source-file="Badge.tsx">{t('vividi_mirror_unlimited_logo_text')}</Message>
    </UnlimitedBadge>;
};
export default Badge;